module.exports = __webpack_public_path__ + "media/images/shopify_faq_url-688532132ee5ea7dafd48f66c8ef57a5.png";